<template >
  <article
    class="md:rounded-t-md py-8 px-6 flex md:flex-row items-center justify-center min-h-banner gap-6"
    :class="[
      { 'md:rounded-b-md': rounded },
      isWhiteBanner ? 'bg-white' : 'bg-primaryDark',
    ]"
  >
    <img
      src="../assets/shop-owner.png"
      alt="Shop Owner holding a mobile phone"
      class="md:w-32 w-28 hidden md:block shopOwner-css"
      v-if="showImage"
    />
    <slot></slot>
  </article>
</template>
<script>
export default {
  name: 'Banner',
  props: {
    rounded: { type: Boolean, required: false, default: true },
    showImage: { type: Boolean, required: false, default: true },
    isWhiteBanner: { type: Boolean, required: false, default: false },
  },
};
</script>
<style lang="scss" scoped>
.rotate-y-180 {
  @media (max-width: 640px) {
    transform: rotateY(180deg);
  }
}
.shopOwner-css{
    margin-right: 50px;
    height: 160px;
    width: 160px;
    margin-bottom: -45px;
  }
</style>
